import * as React from 'react';

function SvgSendOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M21.568 12.676l-19.07 7.865A.349.349 0 012 20.23v-5.06a.357.357 0 01.29-.35l11.056-2.099c.775-.146.775-1.256 0-1.403L2.29 9.218a.357.357 0 01-.29-.35V3.811c0-.256.263-.458.498-.357l19.07 7.91a.715.715 0 010 1.312z" })));
}

export default SvgSendOutline;
